import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VbSegmentedOption } from '@viewbid/ui';
import { PickupSlot } from '../../model/pickup-slot';

@Component({
    selector: 'vb-pickup-time-slots',
    templateUrl: './pickup-time-slots.component.html',
    styleUrls: ['./pickup-time-slots.component.scss'],
})
export class PickupTimeSlotsComponent {
    selectedZone: 'AM' | 'PM' = 'AM';
    selectedSlot: PickupSlot | null = null;
    @Input() morningSlots: PickupSlot[] = [];
    @Input() afternoonSlots: PickupSlot[] = [];
    @Output() pickupSlotSelectedEvent = new EventEmitter<PickupSlot>();

    readonly zoneOptions: VbSegmentedOption[] = [
        { id: 'AM', label: 'AM' },
        { id: 'PM', label: 'PM' },
    ];

    get activeSlots(): PickupSlot[] {
        return this.selectedZone === 'AM'
            ? this.morningSlots
            : this.afternoonSlots;
    }

    selectZone(zone: string): void {
        this.selectedZone = zone === 'PM' ? 'PM' : 'AM';
    }

    selectSlot(slot: PickupSlot): void {
        if (slot.availableSlots > 0) {
            this.selectedSlot = slot;
            this.pickupSlotSelectedEvent.emit(slot);
        }
    }
}
